import { createLogic } from 'redux-logic';
import * as actions from '../actions';
import { getAlertShow } from '../selectors';

let alertTimeout = null;

const displayAlert = createLogic({
  type: actions.displayAlert,
  latest: true,
  async process({ getState }, dispatch, done) {
    const state = getState();
    const showing = getAlertShow(state);

    if (showing) {
      clearTimeout(alertTimeout);
      dispatch(actions.hideAlert());
    }

    dispatch(actions.showAlert());

    alertTimeout = setTimeout(() => {
      dispatch(actions.cleanupAlert());
      done();
    }, 6000);
  },
});

export default displayAlert;
